import React from 'react';
import { ExternalLinkIcon, PlayCircleIcon } from 'lucide-react';
const documentaryUrl = 'https://www.youtube.com/watch?v=Gueajh2wfkY&t=369s';
export function EverythingElseMatters() {
  return <article id="eem" aria-labelledby="eem-title" className="scroll-mt-20 overflow-hidden rounded-lg bg-[#01052a]/80 shadow-xl ring-1 ring-white/15" data-id="element-13" data-mp="10uv7d2j6prci">
      <div className="relative aspect-video w-full overflow-hidden bg-black" data-id="element-14" data-mp="1asje6qu2epb1">
        <iframe className="absolute inset-0 h-full w-full" src="https://www.youtube.com/embed/Gueajh2wfkY?start=369&rel=0" title="Everything Else Matters documentary" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-15" data-mp="1aqge1dz77fsl" />
      </div>

      <div className="grid gap-8 p-6 md:p-10 lg:grid-cols-[1.25fr_0.75fr]" data-id="element-16" data-mp="1tk2egpwpfp9d">
        <div data-id="element-17" data-mp="1okg0ge91y4zi">
          <p className="mb-3 text-sm font-medium text-blue-200" data-id="element-18" data-mp="1okz8n38whf0c">
            A documentary by Improbability Foundation and the OPEN Foundation
          </p>
          <h3 id="eem-title" className="mb-3 text-3xl font-bold md:text-4xl" data-id="element-19" data-mp="1v7c6wmm6gnl5">
            Everything Else Matters
          </h3>
          <p className="mb-6 text-lg italic text-blue-100" data-id="element-20" data-mp="252m9bbghmwzg">
            Deconstructing Psychedelic Experience · Feature documentary · 61
            minutes
          </p>
          <p className="mb-4 text-base leading-7 text-white/90" data-id="element-21" data-mp="2e3txv1t7cjgc">
            Everything Else Matters is a nonprofit documentary project created
            to deepen public understanding of psychedelic experiences.
          </p>
          <p className="text-base leading-7 text-white/90" data-id="element-22" data-mp="2ntdhi9oqohc9">
            The film brings together leading researchers, clinicians, and
            practitioners to examine the science of set, setting, and the inner
            mechanisms of these journeys. Its mission is to make complex
            knowledge accessible, promote safer and more beneficial practices,
            and support an informed, responsible conversation about the
            therapeutic potential of psychedelics.
          </p>
        </div>

        <aside className="flex flex-col justify-between border-t border-white/20 pt-6 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0" data-id="element-23" data-mp="xqmrv3lmm2lw">
          <div data-id="element-24" data-mp="1bj2wg8u6e8ox">
            <h4 className="mb-3 text-lg font-semibold" data-id="element-25" data-mp="1bit1s7y6rdcw">Watch from anywhere</h4>
            <p className="mb-6 text-sm leading-6 text-white/75" data-id="element-26" data-mp="16oyl7ddvnei1">
              The full documentary is available free on the official Everything
              Else Matters YouTube channel.
            </p>
          </div>
          <a href={documentaryUrl} target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-5 py-3 font-semibold text-[#01052a] transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-blue-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#01052a]" data-id="element-27" data-mp="1gifkuy0p3ntm">
            <PlayCircleIcon aria-hidden="true" size={20} data-id="element-28" data-mp="3i41fbmzw86l8" />
            Watch the full documentary
            <ExternalLinkIcon aria-hidden="true" size={16} data-id="element-29" data-mp="3m53e62pwegmo" />
          </a>
        </aside>
      </div>
    </article>;
}